import GoogleCalendarIcon from 'resources/icons/google_calendar_icon.png'
import GmailIcon from 'resources/icons/gmail_icon.png'
import TelegramIcon from 'resources/icons/telegram_icon.png'
import SlackIcon from 'resources/icons/slack_icon.png'
import TrelloIcon from 'resources/icons/trello_icon.png'
import NotionIcon from 'resources/icons/notion_icon.png'
import GdriveIcon from 'resources/icons/gdrive_icon.png'
import GsheetIcon from 'resources/icons/gsheet_icon.png'
import TodoistIcon from 'resources/icons/todoist_icon.png'
import SubmarkLogo from 'resources/Logo/submark-logo-2.png'
import OutlookCalendarIcon from 'resources/icons/outlook_icon.png'
import GithubIcon from 'resources/icons/github_icon.png'

import { 
    getGmailLabels,
    getGoogleCalendars,
    getGoogleCalendarEvents,
    getGmailMessages,
    testTelegram,
    getTrelloBoards,
    getTrelloLists,
    getTrelloLabels,
    testTrello,
    gsheetOnNext,
    getGsheet,
    testGsheet,
    getTodoistProjects,
    getTodoistSections,
    getTodoistLabels,
    testTodoist,
    getOutlookCalendars,
    getOutlookCalendarEvents
} from 'utils'
import { ClientWorkflow } from 'schema'
import * as api from 'api'

export const priorityOptions = {
    'HIGH': {
        title: 'High',
        value: 'HIGH'
    },
    'MEDIUM': {
        title: 'Medium',
        value: 'MEDIUM'
    },
    'LOW': {
        title: 'Low',
        value: 'LOW'
    },
    'NONE': {
        title: 'None',
        value: 'NONE'
    },
}

export const workflowContext = {
    INFLOW: ['GOOGLE_CALENDAR','OUTLOOK_CALENDAR','GSHEET','TRELLO','TODOIST'],
    OUTFLOW: ['TELEGRAM']
    // OUTFLOW: ['TELEGRAM','SLACK']
}

export const clientContext = {
    ATOMICLY: {
        active: false,
        title: 'Atomicly',
        value: 'ATOMICLY',
        icon: { type: 'link', value: SubmarkLogo},
        configurations : {
            priority: {
                pre_requisite: (state) => (state.trigger && state.trigger['trigger'] === 'PriorityItem'),
                required: true,
                label: 'Priority',
                selector: 'Selector',
                options: priorityOptions, 
                key: 'priority'
            },
            tags: {
                pre_requisite: (state) => (state.trigger && state.trigger['trigger'] === 'TagItem' && state.trigger.ext['pageID']),
                required: true,
                label: 'Tags',
                selector: 'TagSelector',
                key: 'tags'
            },
        },
        validation: (payload) => {
            const { workflow } = payload;
            if(workflow.trigger['trigger'] === 'TagItem'){
                if(workflow.trigger.ext['tags'] && workflow.trigger.ext['tags'].length > 0){
                    return { isValid: true, error: null, key: 'tags' }
                } else {
                    return { isValid: false, error: 'Required', key: 'tags' }
                }
            } else if (workflow.trigger['trigger'] === 'PriorityItem') {
                if(workflow.trigger.ext['priority'] && workflow.trigger.ext['priority'].length > 0){
                    return { isValid: true, error: null, key: 'priority' }
                } else {
                    return { isValid: false, error: 'Required', key: 'priority' }
                }
            }
        }
    },
    GOOGLE_CALENDAR: {
        active: true,
        title: 'Google Calendar',
        value: 'GOOGLE_CALENDAR',
        icon: { type: 'link', value: GoogleCalendarIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, redirecting back to Atomicly',
            'failed': 'Authentication failed, redirecting back to Atomicly'
        },
        configurations : {
            calendarId: {
                // pre_requisite: ['clientId'],
                // pre_requisite: (state) => (state.trigger && state.trigger['clientId']),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && newState.trigger['clientId'] !== oldState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select calendar',
                selector: 'Selector',
                // Function to get options
                options: (payload) => getGoogleCalendars(payload), 
                key: 'calendarId'
            },
            match: {
                // pre_requisite: (state) => (state.trigger && ['NewEventMatch', 'AcceptedEventMatch'].includes(state.trigger['trigger'])),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && ['NewEventMatch', 'AcceptedEventMatch'].includes(newState.trigger['trigger'])
                    const shouldUpdate = validation && isValid && oldState.trigger['trigger'] !== newState.trigger['trigger']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input matching text',
                selector: 'Text',
                key: 'match'
            }
        },
        syncWorkflow: async(payload) => {
            return api.syncGoogleCalendar({workflowId: payload['workflowId']})
                .then(syncRes => { return { success: true } })
                .catch(syncErr => { return { success: false } })
        },
        test: {
            INFLOW: {
                'NewEvent': (payload) => getGoogleCalendarEvents(payload, 'NewEvent'),
                'NewEventMatch': (payload) => getGoogleCalendarEvents(payload, 'NewEventMatch'),
                'AcceptedEvent': (payload) => getGoogleCalendarEvents(payload, 'AcceptedEvent'),
                'AcceptedEventMatch': (payload) => getGoogleCalendarEvents(payload, 'AcceptedEventMatch')
            }
        }
    },
    OUTLOOK_CALENDAR: {
        active: true,
        title: 'Outlook Calendar',
        value: 'OUTLOOK_CALENDAR',
        icon: { type: 'link', value: OutlookCalendarIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
        configurations: {
            calendarId: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && newState.trigger['clientId'] !== oldState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select calendar',
                selector: 'Selector',
                // Function to get options
                options: (payload) => getOutlookCalendars(payload), 
                key: 'calendarId'
            },
            match: {
                // pre_requisite: (state) => (state.trigger && ['NewEventMatch', 'AcceptedEventMatch'].includes(state.trigger['trigger'])),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && ['NewEventMatch', 'AcceptedEventMatch'].includes(newState.trigger['trigger'])
                    const shouldUpdate = validation && isValid && oldState.trigger['trigger'] !== newState.trigger['trigger']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input matching text',
                selector: 'Text',
                key: 'match'
            }
        },
        test: {
            INFLOW: {
                'NewEvent': (payload) => getOutlookCalendarEvents(payload, 'NewEvent'),
                'NewEventMatch': (payload) => getOutlookCalendarEvents(payload, 'NewEventMatch'),
                'AcceptedEvent': (payload) => getOutlookCalendarEvents(payload, 'AcceptedEvent'),
                'AcceptedEventMatch': (payload) => getOutlookCalendarEvents(payload, 'AcceptedEventMatch')
            }
        },
        syncWorkflow: async(payload) => {
            return api.syncOutlookCalendar({workflowId: payload['workflowId']})
                .then(syncRes => { return { success: true } })
                .catch(syncErr => { return { success: false } })
        },
    },
    GMAIL: {
        active: false,
        title: 'Gmail',
        value: 'GMAIL',
        icon: { type: 'link', value: GmailIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, redirecting back to Atomicly',
            'failed': 'Authentication failed, redirecting back to Atomicly'
        },
        configurations: {
            labelId: {
                // pre_requisite: (state) => (state.trigger && state.trigger['trigger'] && state.trigger['clientId'] && ['NewLabeledEmail'].includes(state.trigger['trigger'])),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const isValid = newState.trigger && newState.trigger['trigger'] && newState.trigger['clientId'] && ['NewLabeledEmail'].includes(newState.trigger['trigger'])
                    const shouldUpdate = isValid && (newState.trigger['trigger'] !== oldState.trigger['trigger']) || (newState.trigger['clientId'] !== oldState.trigger['clientId'])
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select label/mailbox',
                selector: 'Selector',
                options: (payload) => getGmailLabels(payload),
                key: 'labelId'
            },
            match: {
                // pre_requisite: (state) => (state.trigger && state.trigger['trigger'] && ['EmailContentMatch','EmailSubjectMatch'].includes(state.trigger['trigger'])),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const isValid = newState.trigger && newState.trigger['trigger'] && ['EmailContentMatch','EmailSubjectMatch'].includes(newState.trigger['trigger'])
                    const shouldUpdate = isValid && (newState.trigger['trigger'] !== oldState.trigger['trigger'])
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input matching text',
                selector: 'Text',
                key: 'match'
            },
            from: {
                // pre_requisite: (state) => (state.trigger && state.trigger['trigger'] && ['FromEmail'].includes(state.trigger['trigger'])),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const isValid = newState.trigger && newState.trigger['trigger'] && ['FromEmail'].includes(newState.trigger['trigger'])
                    const shouldUpdate = isValid && (newState.trigger['trigger'] !== oldState.trigger['trigger'])
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: "Input sender's email",
                selector: 'Text',
                key: 'from'
            }
        },
        test: {
            INFLOW: {
                'NewEmail': (payload) => getGmailMessages(payload, 'NewEmail'),
                'NewEmailMatch': (payload) => getGmailMessages(payload, 'NewEmailMatch'),
                'NewLabeledEmail': (payload) => getGmailMessages(payload, 'NewLabeledEmail'),
                'NewStarredEmail': (payload) => getGmailMessages(payload, 'NewStarredEmail')
            }
        }
    },
    GDRIVE: {
        active: false,
        title: 'Google Drive',
        value: 'GDRIVE',
        icon: { type: 'link', value: GdriveIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
    },
    GSHEET: {
        active: true,
        title: 'Google Sheets',
        value: 'GSHEET',
        icon: { type: 'link', value: GsheetIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
        onNext: gsheetOnNext,
        configurations: {
            sheetUrl: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && oldState.trigger['clientId'] !== newState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input Gsheet URL',
                selector: 'Text',
                key: 'sheetUrl',
            },
            rangeId: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && oldState.trigger['clientId'] !== newState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input Gsheet Range',
                subtitle: 'First row should be the headers',
                selector: 'Text',
                key: 'rangeId',
                helper: 'Range to read data from (e.g. Sheet1!A1:D)'
            },
            idColumn: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && oldState.trigger['clientId'] !== newState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input ID Column',
                selector: 'Text',
                value: 'idColumn',
                helper: 'Column used to identify each row'
                // options: (payload) => getGsheet(payload), 
            },
            conditions: {
                pre_requisite: (payload) => {
                    
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState && oldState.trigger && newState && newState.trigger && oldState.trigger.ext && newState.trigger.ext
                    const isValid = validation && newState.trigger['trigger'] === 'FilterRow'
                    const shouldUpdate = validation && isValid && (
                        (oldState.trigger.ext['rangeId'] !== newState.trigger.ext['rangeId']) |
                        (oldState.trigger.ext['sheetUrl'] !== newState.trigger.ext['sheetUrl']) |
                        (!newState.trigger.ext['rangeId'] && !newState.trigger.ext['rangeId'])
                    )
                    // console.log(payload, { isValid, shouldUpdate, oldState, newState })
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Input Conditions',
                selector: 'Conditional',
                value: 'conditions',
                options: (payload) => getGsheet(payload)
            }
        },
        titleOptions: (workflow) => {
            let options = {
                // sheetName: { title: 'Sheet Name', value: 'sheetName' },
                // rangeId: { title: 'Range Name', value: 'rangeId' }
            }
            const headers = workflow.trigger.ext['headers']
            headers.map((header,index) => {
                // options[index.toString()] = { title: header.toString(), value: index.toString()}
                options[header.toString()] = { title: header.toString(), value: header.toString()}
            })
            return options
        },
        notesOptions: (workflow) => {
            let options = {
                sheetName: { title: 'Sheet Name', value: 'sheetName' },
                rangeId: { title: 'Range Name', value: 'rangeId' }
            }
            const headers = workflow.trigger.ext['headers']
            headers.map((header,index) => {
                // options[index.toString()] = { title: header.toString(), value: index.toString()}
                options[header.toString()] = { title: header.toString(), value: header.toString()}
            })
            return options
        },
        syncWorkflow: async(payload) => {
            return api.syncGsheet({workflowId: payload['workflowId']})
                .then(syncRes => { return { success: true } })
                .catch(syncErr => { return { success: false } })
        },
        validation: (payload) => {
            const {
                workflow,
                userId
            } = payload
            if(workflow.trigger['trigger'] === 'FilterRow'){
                const conditions = workflow.trigger.ext['conditions']
                const check = conditions ? conditions.map(condition => {
                    return Object.values(condition).includes(null)
                }) : []
                if(check.includes(true)){
                    return { isValid: false, error: 'Incomplete fields', key: 'conditions' }
                } else {
                    return { isValid: true, error: null, key: 'conditions'  }
                }
            } else {
                return { isValid: true, error: null, key: 'conditions'  }
            }
        },
        test: {
            INFLOW: {
                NewRow: (payload) => testGsheet(payload, 'NewRow'),
                FilterRow: (payload) => testGsheet(payload, 'FilterRow')
            }
        }
    },
    TELEGRAM: {
        active: true,
        title: 'Telegram',
        value: 'TELEGRAM',
        icon: { type: 'link', value: TelegramIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
        test: {
            OUTFLOW: {
                'SendMessage': (payload) => testTelegram(payload,'SendMessage')
            }
        }
    },
    TRELLO: {
        active: true,
        title: 'Trello',
        value: 'TRELLO',
        icon: { type: 'link', value: TrelloIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
        configurations: {
            boardId: {
                // pre_requisite: (state) => (state.trigger && state.trigger['clientId']),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState.trigger && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && oldState.trigger['clientId'] !== newState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select Board',
                selector: 'Selector',
                key: 'boardId',
                options: (payload) => getTrelloBoards(payload)
            },
            listId: {
                // pre_requisite: (state) => (state.trigger && state.trigger.ext && state.trigger['clientId'] && state.trigger.ext['boardId'] ),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = (oldState.trigger) && (newState.trigger)
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                                    && newState.trigger.ext && newState.trigger.ext['boardId']
                    const shouldUpdate = validation && isValid && (
                        (oldState.trigger['clientId'] !== newState.trigger['clientId']) || 
                        (!oldState.trigger.ext && newState.trigger.ext && newState.trigger.ext['boardId']) || 
                        (oldState.trigger.ext['boardId'] !== newState.trigger.ext['boardId'])
                    )
                    console.log({oldState, newState, isValid, shouldUpdate})
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select List',
                selector: 'Selector',
                key: 'listId',
                options: (payload) => getTrelloLists(payload)
            },
            labelIds: {
                // pre_requisite: (state) => (state.trigger && state.trigger['trigger'] && state.trigger['clientId'] && ['CardLabelled'].includes(state.trigger['trigger'])),
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState.trigger && newState.trigger
                    const isValid = validation && newState.trigger['trigger'] 
                                    && (newState['clientId'] || newState.trigger['clientId'])
                                    && ['CardLabelled'].includes(newState.trigger['trigger'])
                    const shouldUpdate = validation && isValid && (oldState.trigger['trigger'] !== newState.trigger['trigger']) || (oldState.trigger['clientId'] !== newState.trigger['clientId'])
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select Label(s)',
                selector: 'MultiSelector',
                options: (payload) => getTrelloLabels(payload),
                key: 'labelIds'
            },
        },
        test: {
            INFLOW: {
                NewCard: (payload) => testTrello(payload),
                CardScheduled: (payload) => testTrello(payload),
                CardLabelled: (payload) => testTrello(payload),
            }
        },
        syncWorkflow: async(payload) => {
            return api.syncTrello({workflowId: payload['workflowId']})
                .then(syncRes => { return { success: true } })
                .catch(syncErr => { return { success: false } })
        },
    },
    TODOIST: {
        active: true,
        title: 'Todoist',
        value: 'TODOIST',
        icon: { type: 'link', value: TodoistIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
        configurations: {
            projectId: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState.trigger && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId'])
                    const shouldUpdate = validation && isValid && oldState.trigger['clientId'] !== newState.trigger['clientId']
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select project',
                selector: 'Selector',
                key: 'projectId',
                options: (payload) => getTodoistProjects(payload)
            },
            sectionId: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    const validation = oldState.trigger && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId']) && newState.trigger.ext && newState.trigger.ext['projectId']
                    const shouldUpdate = validation && isValid && (oldState.trigger['clientId'] !== newState.trigger['clientId'] || (!oldState.trigger.ext && newState.trigger.ext && newState.trigger.ext['projectId']) || (oldState.trigger.ext['projectId'] !== newState.trigger.ext['projectId']))
                    console.log({validation, isValid, shouldUpdate, payload})
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select section',
                selector: 'Selector',
                key: 'sectionId',
                options: (payload) => getTodoistSections(payload)
            },
            labelIds: {
                pre_requisite: (payload) => {
                    const oldState = payload['old']
                    const newState = payload['new']
                    
                    const validation = oldState.trigger && newState.trigger
                    const isValid = validation && (newState['clientId'] || newState.trigger['clientId']) && newState.trigger['trigger'] === 'TaskLabelled'
                    const shouldUpdate = validation && isValid && (
                        (oldState.trigger['clientId'] !== newState.trigger['clientId']) ||
                        (oldState.trigger['trigger'] !== newState.trigger['trigger'])
                    )
                    return { isValid, shouldUpdate }
                },
                required: true,
                label: 'Select label(s)',
                selector: 'MultiSelector',
                key: 'labelIds',
                options: (payload) => getTodoistLabels(payload)
            },
        },
        test: {
            INFLOW: {
                NewTask: (payload) => testTodoist(payload, 'NewTask'),
                TaskScheduled: (payload) => testTodoist(payload, 'NewTask'),
                TaskLabelled: (payload) => testTodoist(payload, 'NewTask'),
            }
        },
        syncWorkflow: async(payload) => {
            return api.syncTodoist({workflowId: payload['workflowId']})
                .then(syncRes => { return { success: true } })
                .catch(syncErr => { return { success: false } })
        },
    },
    NOTION: {
        active: false,
        title: 'Notion',
        value: 'NOTION',
        icon: { type: 'link', value: NotionIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
    },
    SLACK: {
        active: false,
        title: 'Slack',
        value: 'SLACK',
        icon: { type: 'link', value: SlackIcon}
    },
    GITHUB: {
        active: false,
        title: 'Github',
        value: 'GITHUB',
        icon: { type: 'link', value: GithubIcon },
        redirectionMsg: {
            'success': 'Authentication succesful, you may close this page.',
            'failed': 'Authentication failed, please try again.'
        },
        configurations: {},
    },
}

export const triggerContext = {
    GOOGLE_CALENDAR: {
        'NewEvent': {
            title: 'New Event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
        'NewEventMatch': {
            title: 'New Event Matching Search',
            subtitle: 'Triggers when a new event is created that matches a search',
            value: 'NewEventMatch'
        },
        'AcceptedEvent': {
            title: 'Accepted Event',
            subtitle: 'Triggers when a new event is accepted',
            value: 'AcceptedEvent'
        },
        'AcceptedEventMatch': {
            title: 'New Accepted Event Matching Search',
            subtitle: 'Triggers when a new event is accepted that matches a search',
            value: 'AcceptedEventMatch'
        },
    },
    GMAIL: {
        'NewEmail': {
            title: 'New Email',
            subtitle: 'Triggers when you receive a new email',
            value: 'NewEmail'
        },
        'EmailContentMatch': {
            title: 'Email Content Matching Search',
            subtitle: 'Triggers when a new email content matches a search',
            value: 'EmailContentMatch'
        },
        'EmailSubjectMatch': {
            title: 'Email Subject Matching Search',
            subtitle: 'Triggers when a new email subject matches a search',
            value: 'EmailSubjectMatch'
        },
        'FromEmail': {
            title: 'Email From Target',
            subtitle: 'Triggers when you receive a new email from a target sender',
            value: 'FromEmail'
        },
        'NewLabeledEmail': {
            title: 'New Labelled Email',
            subtitle: 'Triggers when you label an email',
            value: 'NewLabeledEmail'
        },
        'NewStarredEmail': {
            title: 'New Starred Email',
            subtitle: 'Triggers when you star an email',
            value: 'NewStarredEmail'
        },
    },
    TELEGRAM: {
        'SendMessage': {
            title: 'Send Message',
            subtitle: 'Triggers a notification via the Atomicly Bot in Telegram',
            value: 'SendMessage'
        },
    },
    SLACK: {
        'NewEvent': {
            title: 'New event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
    },
    ATOMICLY: {
        'CreateItem': {
            title: 'Create Item',
            subtitle: 'Create an item in Atomicly in the specified page and section',
            value: 'CreateItem'
        },
    },
    TRELLO: {
        'NewCard': {
            title: 'New Card',
            subtitle: 'Triggers when a new card is created',
            value: 'NewCard'
        },
        // 'CardArchived': {
        //     title: 'Card Archived',
        //     subtitle: 'Triggers when a card gets archived',
        //     value: 'CardArchived'
        // },
        'CardScheduled': {
            title: 'Schedule Card',
            subtitle: 'Triggers when Start/Due date is added to a card',
            value: 'CardScheduled'
        },
        'CardLabelled': {
            title: 'Label Card',
            subtitle: 'Triggers when a the specified labels are added to a card',
            value: 'CardLabelled'
        },
        // 'CardDue': {
        //     title: 'Card Due',
        //     subtitle: 'Triggers a specified time befeore the card due time',
        //     value: 'CardDue'
        // }
    },
    GSHEET: {
        'NewRow': {
            title: 'New Row',
            subtitle: 'Triggers when a new row is added',
            value: 'NewRow'
        },
        'FilterRow': {
            title: 'Filtered Row',
            subtitle: 'Triggers when a row meets the specified conditions',
            value: 'FilterRow'
        },
    },
    TODOIST: {
        'NewTask': {
            title: 'New Task',
            subtitle: 'Triggers when a new task is created',
            value: 'NewTask'
        },
        'TaskScheduled': {
            title: 'Schedule Task',
            subtitle: 'Triggers when due date is added to a task',
            value: 'TaskScheduled'
        },
        'TaskLabelled': {
            title: 'Label Task',
            subtitle: 'Triggers when a the specified labels are added to a task',
            value: 'TaskLabelled'
        },
    },
    OUTLOOK_CALENDAR: {
        'NewEvent': {
            title: 'New Event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
        'NewEventMatch': {
            title: 'New Event Matching Search',
            subtitle: 'Triggers when a new event is created that matches a search',
            value: 'NewEventMatch'
        },
        'AcceptedEvent': {
            title: 'Accepted Event',
            subtitle: 'Triggers when a new event is accepted',
            value: 'AcceptedEvent'
        },
        'AcceptedEventMatch': {
            title: 'New Accepted Event Matching Search',
            subtitle: 'Triggers when a new event is accepted that matches a search',
            value: 'AcceptedEventMatch'
        },
    },
}

export const titleContext = {
    GOOGLE_CALENDAR: {
        'summary': {
            title: 'Event Name',
            value: 'summary'
        },
        'description': {
            title: 'Description',
            value: 'description'
        },
        'location': {
            title: 'Location',
            value: 'location'
        },
        'organizer': {
            title: 'Organizer',
            value: 'organizer'
        },
    },
    GMAIL: {
        'snippet': {
            title: 'Email Preview',
            value: 'snippet'
        },
        'subject': {
            title: 'Email Subject',
            value: 'subject'
        },
        'from': {
            title: 'Sender Email',
            value: 'from'
        },
        'date': {
            title: 'Date Received',
            value: 'date'
        },
    },
    TELEGRAM: {
        'NewEvent': {
            title: 'New event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
    },
    SLACK: {
        'NewEvent': {
            title: 'New event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
    },
    TRELLO: {
        'name': {
            title: 'Card Name',
            value: 'name'
        },
    },
    TODOIST: {
        'content': {
            title: 'Task Content',
            value: 'content'
        },
        'description': {
            title: 'Task Description',
            value: 'description'
        },
    },
    OUTLOOK_CALENDAR: {
        'subject': {
            title: 'Subject',
            value: 'subject'
        },
    },
}

export const notesContext = {
    GOOGLE_CALENDAR: {
        'summary': {
            title: 'Event Name',
            value: 'summary'
        },
        // 'description': {
        //     title: 'Description',
        //     value: 'description'
        // },
        'location': {
            title: 'Location',
            value: 'location'
        },
        'organizer': {
            title: 'Organizer',
            value: 'organizer'
        },
        // 'EventAttachedFiles': {
        //     title: 'Attached Files',
        //     value: 'EventAttachedFiles'
        // },
        'hangoutLink': {
            title: 'Google Meet Link',
            value: 'hangoutLink'
        }
    },
    GMAIL: {
        'snippet': {
            title: 'Email Preview',
            value: 'snippet'
        },
        'subject': {
            title: 'Email Subject',
            value: 'subject'
        },
        'from': {
            title: 'Sender Email',
            value: 'from'
        },
        'date': {
            title: 'Date Received',
            value: 'date'
        },
    },
    TELEGRAM: {
        'NewEvent': {
            title: 'New event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
    },
    SLACK: {
        'NewEvent': {
            title: 'New event',
            subtitle: 'Triggers when a new event is created',
            value: 'NewEvent'
        },
    },
    TRELLO: {
        'name': {
            title: 'Card Name',
            value: 'name'
        },
        'desc': {
            title: 'Card Description',
            value: 'desc'
        },
        'start': {
            title: 'Start date',
            value: 'start'
        },
        'due': {
            title: 'Due date',
            value: 'due'
        },
        'labels': {
            title: 'Labels',
            value: 'labels'
        },
        'url': {
            title: 'Card URL',
            value: 'url'
        },
        'board': {
            title: 'Board',
            value: 'board'
        },
        'list': {
            title: 'List',
            value: 'list'
        },
    },
    TODOIST: {
        'content': {
            title: 'Task Content',
            value: 'content'
        },
        'description': {
            title: 'Task Description',
            value: 'description'
        },
        'priority': {
            title: 'Priority',
            value: 'priority'
        },
        'project': {
            title: 'Project',
            value: 'project'
        },
        'section': {
            title: 'Section',
            value: 'section'
        },
        'due': {
            title: 'Due Date',
            value: 'due'
        },
        'date_added': {
            title: 'Created Date',
            value: 'date_added'
        },
        'labels': {
            title: 'Labels',
            value: 'labels'
        },
    },
    OUTLOOK_CALENDAR: {
        'subject': {
            title: 'Subject',
            value: 'subject'
        },
        'bodyPreview': {
            title: 'Body',
            value: 'bodyPreview'
        },
        'onlineMeetingUrl': {
            title: 'Meeting Link',
            value: 'onlineMeetingUrl'
        },
        'webLink': {
            title: 'Event Link',
            value: 'webLink'
        },
        'organizer': {
            title: 'Organizer',
            value: 'organizer'
        },
        'location': {
            title: 'Location',
            value: 'location'
        }
    },
}

export const suggestedWorkflows = (uid) => ([
    {
        title: 'Create task from calendar event',
        subtitle: 'Google Calendar',
        workflow: new ClientWorkflow({
            direction: 'INFLOW',
            client: 'GOOGLE_CALENDAR',
            trigger: {
                client: 'GOOGLE_CALENDAR',
                trigger: 'NewEvent'
            }
        }),
        triggerIcon: clientContext['GOOGLE_CALENDAR'].icon,
        actionIcon: { type: 'link', value: SubmarkLogo },
    },
    // {
    //     title: 'Create task from new email tagged',
    //     subtitle: 'Gmail',
    //     workflow: new ClientWorkflow({
    //         direction: 'INFLOW',
    //         client: 'GMAIL',
    //         trigger: {
    //             client: 'GMAIL',
    //             trigger: 'NewLabeledEmail'
    //         }
    //     }),
    //     triggerIcon: clientContext['GMAIL'].icon,
    //     actionIcon: { type: 'link', value: SubmarkLogo },
    // },
    // {
    //     title: 'Create task from new starred email',
    //     subtitle: 'Gmail',
    //     workflow: new ClientWorkflow({
    //         direction: 'INFLOW',
    //         client: 'GMAIL',
    //         trigger: {
    //             client: 'GMAIL',
    //             trigger: 'NewStarredEmail'
    //         }
    //     }),
    //     triggerIcon: clientContext['GMAIL'].icon,
    //     actionIcon: { type: 'link', value: SubmarkLogo },
    // },
    {
        title: 'Send message when task is completed',
        subtitle: 'Telegram',
        workflow: new ClientWorkflow({
            direction: 'OUTFLOW',
            client: 'TELEGRAM',
            action: {
                client: 'TELEGRAM',
                action: 'SendMessage',
                ext: {}
            },
            trigger: {
                client: 'ATOMICLY',
                clientId: uid,
                trigger: 'CompleteItem',
                ext: {}
            }
        }),
        triggerIcon: clientContext['TELEGRAM'].icon,
        actionIcon: { type: 'link', value: SubmarkLogo },
    },
    {
        title: 'Create task assigned to you from team tracker',
        subtitle: 'Google Sheets',
        workflow: new ClientWorkflow({
            direction: 'INFLOW',
            client: 'GSHEET',
            trigger: {
                client: 'GSHEET',
                trigger: 'FilterRow'
            }
        }),
        triggerIcon: clientContext['GSHEET'].icon,
        actionIcon: { type: 'link', value: SubmarkLogo },
    },
    {
        title: 'Create task from Trello board',
        subtitle: 'Trello',
        workflow: new ClientWorkflow({
            direction: 'INFLOW',
            client: 'TRELLO',
            trigger: {
                client: 'TRELLO',
                trigger: 'NewCard'
            }
        }),
        triggerIcon: clientContext['TRELLO'].icon,
        actionIcon: { type: 'link', value: SubmarkLogo },
    },
    {
        title: 'Create task from Todoist',
        subtitle: 'Todoist',
        workflow: new ClientWorkflow({
            direction: 'INFLOW',
            client: 'TODOIST',
            trigger: {
                client: 'TODOIST',
                trigger: 'NewTask'
            }
        }),
        triggerIcon: clientContext['TODOIST'].icon,
        actionIcon: { type: 'link', value: SubmarkLogo },
    },
])

export const outflowTriggers = {
    'StartScheduleItem': {
        title: 'Before Event',
        subtitle: 'Triggers before an item is scheduled to start',
        value: 'StartScheduleItem'
    },
    'CreateItem': {
        title: 'Create Item',
        subtitle: 'Triggers when a new item is created',
        value: 'CreateItem'
    },
    'CompleteItem': {
        title: 'Complete Item',
        subtitle: 'Triggers when an item is completed',
        value: 'CompleteItem'
    },
    'ScheduleItem': {
        title: 'Schedule Item',
        subtitle: 'Triggers when an item is scheduled',
        value: 'ScheduleItem'
    },
    'TagItem': {
        title: 'Tag Item',
        subtitle: 'Triggers when the specified labels are applied to an item',
        value: 'TagItem'
    },
    'PriorityItem': {
        title: 'Set Priority',
        subtitle: 'Triggers when an item priority level increases',
        value: 'PriorityItem'
    },
    
}